'use strict';

/**
 * Verifica che il parametro in input  sia una stringa
 * @param mixed
 * @returns {boolean}
 */
module.exports = function isString(mixed) {
    return typeof(mixed) === 'string';
};
